import indexedDB from '@/db/index';
import Api from '@/api/index';

const Department = {
  namespaced: true,

  state: {
    all_departments: null,
    one_department: null,
  },

  getters: {
    getAllDepartments: (state) => {
      return state.all_departments;
    },
    getOneDepartment: (state) => {
      return state.one_department;
    }
  },

  mutations: {
    setAllDepartments(state, departments) {
      state.all_departments = [...departments];
    },
    setOneDepartment(state, department) {
      state.one_department = {...department};
    },
    pushToAllDepartments(state, department) {
      state.all_departments.push({...department});
    }
  },

  actions: {
    index(context) {
      Api.Department.index().then(r => r.data).then(departments => {
        context.commit('setAllDepartments', departments);
      }).catch(error => {
        console.log(error);
      });
    },
    create(context, department) {
      Api.Department.create(department).then(r => r.data).then(r => {
        context.commit('pushToAllDepartments', r);
        return true
      }).catch(error => {
        console.log(error);
      }) 
    }
  }
};

export default Department;
